module.exports = __webpack_public_path__ + "img/operator2.467b0e72.png";